import { render, staticRenderFns } from "./ToggleButton.vue?vue&type=template&id=58725c92"
import script from "./ToggleButton.vue?vue&type=script&lang=ts"
export * from "./ToggleButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports